import { useEffect } from "react";
import { NEWSLETTER_WEEK44_EN_HTML } from "@/data/newsletterWeek44En";

function useNoIndex(title) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.title = prevTitle;
      document.head.removeChild(meta);
    };
  }, [title]);
}

export default function NewsletterWeek44En() {
  useNoIndex("Maison Core — Newsletter Week 44");
  return (
    <div className="min-h-screen px-3 py-8 sm:px-6 sm:py-14" style={{ background: "#C2AA9D" }} data-testid="newsletter-week44-en">
      <style>{`
        .nl-card table[width="600"] { width: 100% !important; }
        .nl-card img { max-width: 100% !important; height: auto !important; }
      `}</style>
      <div
        className="nl-card mx-auto w-full shadow-lg"
        style={{ maxWidth: 600 }}
        dangerouslySetInnerHTML={{ __html: NEWSLETTER_WEEK44_EN_HTML }}
      />
    </div>
  );
}
